import { useState, Dispatch } from "react";
import OtpInput from "react18-input-otp";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import { useModal } from "../../Sliders/Modal/ModalContext";
import VerifyCoutdown from "../../util/VerifyCoutdown";

const ORANGE = "#FF6A1A";
const NAVY = "#101535";

const Second = ({ currPage, setCurrPage, modalId }: any) => {
  const dispatch: Dispatch<any> = useDispatch();
  const email = useSelector((state: any) => state.client.email);
  const loading = useSelector((state: any) => state.client.loading);
  const { hideModal } = useModal();

  const [otp, setOtp] = useState("");

  const handleVerify = () => {
    dispatch(
      Actions.verifyClient(
        { email, otp },
        (data: any) => {
          if (data.token) {
            if (data.client.fullname && data.client.phone) {
              hideModal(modalId);
              setCurrPage(1);
            } else {
              setCurrPage(currPage + 1);
            }
          } else {
            hideModal(modalId);
          }
        },
        () => {},
      ),
    );
  };

  return (
    <div className="flex flex-col h-full">
      <style>{`
        .otp-wrap input:focus {
          border-color: ${ORANGE} !important;
          box-shadow: 0 0 0 3px rgba(255,106,26,.12) !important;
          background: #fff !important;
          outline: none !important;
        }
      `}</style>

      {/* Heading */}
      <div style={{ marginBottom: 24, marginTop: 4 }}>
        <h2
          style={{
            fontFamily: '"Bricolage Grotesque", sans-serif',
            fontSize: 26,
            fontWeight: 700,
            color: NAVY,
            letterSpacing: -0.5,
            marginBottom: 6,
          }}
        >
          Check your email
        </h2>
        <p style={{ color: "#6C7088", fontSize: 14, lineHeight: 1.6 }}>
          We sent a 6-digit code to{" "}
          <strong style={{ color: NAVY, fontWeight: 700 }}>{email}</strong>
        </p>
      </div>

      {/* OTP inputs */}
      <div className="otp-wrap" style={{ marginBottom: 20 }}>
        <OtpInput
          value={otp}
          onChange={(val: any) => setOtp(val)}
          numInputs={6}
          isInputNum={true}
          containerStyle={{
            display: "flex",
            gap: "8px",
            justifyContent: "space-between",
          }}
          inputStyle={{
            flex: 1,
            height: "58px",
            width: "100%",
            background: "#FAF6F0",
            border: "1.5px solid #E7E0D5",
            borderRadius: "12px",
            color: NAVY,
            fontSize: "24px",
            fontWeight: 700,
            fontFamily: "inherit",
            transition: "border-color .18s, box-shadow .18s",
          }}
        />
      </div>

      {/* Verify button */}
      <button
        type="button"
        onClick={handleVerify}
        disabled={loading || otp.length < 6}
        style={{
          width: "100%",
          height: 52,
          background: loading || otp.length < 6 ? "#E8C4A8" : ORANGE,
          color: "#fff",
          border: "none",
          borderRadius: 13,
          fontWeight: 700,
          fontSize: 15,
          cursor: loading || otp.length < 6 ? "not-allowed" : "pointer",
          fontFamily: "inherit",
          boxShadow:
            otp.length === 6 && !loading
              ? "0 6px 20px -6px rgba(255,106,26,.5)"
              : "none",
          transition: "background .2s",
          marginBottom: 20,
        }}
        onMouseOver={(e) => {
          if (!loading && otp.length === 6)
            (e.currentTarget as HTMLElement).style.background = "#E8550B";
        }}
        onMouseOut={(e) => {
          if (!loading && otp.length === 6)
            (e.currentTarget as HTMLElement).style.background = ORANGE;
        }}
      >
        {loading ? "Verifying…" : "Verify code"}
      </button>

      {/* Expiry */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          fontSize: 13,
          color: "#9CA3AF",
        }}
      >
        <span>Code expires in</span>
        <span style={{ fontWeight: 600, color: "#6C7088" }}>
          <VerifyCoutdown action={() => setCurrPage(1)} />
        </span>
      </div>
    </div>
  );
};

export default Second;
